package com.mgacreative.hotel.core.tenant

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

data class SessionState(
    val userId: String? = null,
    val email: String? = null,
    val fullName: String? = null,
    val hotelName: String? = null,
    val phone: String? = null,
    val tenantId: String? = null,
    val memberCode: String? = null,
    val role: UserRole = UserRole.SUPER_ADMIN,
    val roles: List<String> = emptyList(),
    val allowedModules: List<String> = listOf("FRONT_DESK", "ROOM_STATUS", "STAFF", "SYSTEM"),
    val isAuthenticated: Boolean = false,
    val isDemoMode: Boolean = false
)

class TenantSession {
    private val _sessionState = MutableStateFlow(SessionState())
    val sessionState: StateFlow<SessionState> = _sessionState.asStateFlow()

    val isDemoMode: Boolean
        get() = _sessionState.value.isDemoMode

    val currentUserId: String?
        get() = _sessionState.value.userId

    val currentEmail: String?
        get() = _sessionState.value.email

    val currentFullName: String?
        get() = _sessionState.value.fullName

    val currentHotelName: String?
        get() = _sessionState.value.hotelName

    val currentPhone: String?
        get() = _sessionState.value.phone

    val currentTenantId: String?
        get() = _sessionState.value.tenantId

    val currentMemberCode: String?
        get() = _sessionState.value.memberCode

    val currentRole: UserRole
        get() = _sessionState.value.role
        
    val currentRoles: List<String>
        get() = _sessionState.value.roles

    val currentAllowedModules: List<String>
        get() = _sessionState.value.allowedModules

    fun updateSession(
        userId: String,
        tenantId: String,
        role: UserRole = UserRole.SUPER_ADMIN,
        roles: List<String> = emptyList(),
        memberCode: String? = null,
        email: String? = null,
        fullName: String? = null,
        hotelName: String? = null,
        phone: String? = null,
        isDemoMode: Boolean = false,
        allowedModules: List<String> = listOf("FRONT_DESK", "ROOM_STATUS", "STAFF", "SYSTEM")
    ) {
        _sessionState.value = SessionState(
            userId = userId,
            email = email,
            fullName = fullName,
            hotelName = hotelName,
            phone = phone,
            tenantId = tenantId,
            memberCode = memberCode,
            role = role,
            roles = roles,
            allowedModules = allowedModules,
            isAuthenticated = true,
            isDemoMode = isDemoMode
        )
    }

    fun clearSession() {
        _sessionState.value = SessionState()
    }
    
    // Yardımcı: Sadece admin mi?
    fun isSuperAdmin(): Boolean = currentRole == UserRole.SUPER_ADMIN
    
    // Yardımcı: Belirli bir role sahip mi?
    fun hasRole(roleName: String): Boolean {
        // Eğer SUPER_ADMIN veya HOTEL_OWNER ise her şeye yetkisi olsun
        if (currentRole == UserRole.SUPER_ADMIN || currentRole == UserRole.HOTEL_OWNER) return true
        return currentRoles.contains(roleName)
    }

    // Yardımcı: Belirli bir departmana / hizmete izin verilmiş mi?
    fun hasModule(moduleKey: String): Boolean {
        if (isDemoMode || isSuperAdmin() || currentRole == UserRole.HOTEL_OWNER) return true
        val normalizedKey = moduleKey.uppercase().trim()
        return currentAllowedModules.any { it.equals(normalizedKey, ignoreCase = true) }
    }
}

